import { render, staticRenderFns } from "./EventPhoto.vue?vue&type=template&id=2bef361a"
import script from "./EventPhoto.vue?vue&type=script&lang=js"
export * from "./EventPhoto.vue?vue&type=script&lang=js"
import style0 from "./EventPhoto.vue?vue&type=style&index=0&id=2bef361a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports